<template>
  <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" width="1280px" @close="onBatchModifyCancel">
    <div slot="title">
      <div class="modal-title">
        <h4>{{ title }}</h4>
        <span v-if="rows && rows.length">已选{{ rows.length }}个账号</span>
      </div>
    </div>
    <el-form class="ghost-button-styles" label-width="80px">
      <el-form-item label="统一设置">
        <el-radio-group v-model="form.settingType">
          <el-radio-button v-for="settingType in settingTypes" :key="settingType.value" ghost :label="settingType.value">
            {{ settingType.label }}
          </el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item>
        <div class="input-row">
          <el-select v-model="form.bidType">
            <el-option label="指定出价" :value="1"></el-option>
          </el-select>
          <el-input class="bid-input" v-model="form.bidValue" @keyup.enter.native="onBidValueConfirm" @blur="onBidValueConfirm">
            <template slot="append">
              <el-select :value="form.unitType">
                <el-option label="元" :value="1"></el-option>
              </el-select>
            </template>
          </el-input>
          <el-button type="primary" @click="onBidValueConfirm">确认</el-button>
        </div>
      </el-form-item>
    </el-form>

    <el-table ref="table" class="common-el-table-styles" border :data="rows" :height="320" width="100%">
      <el-table-column prop="index" label="序号">
        <template slot-scope="{ $index }">
          <div>{{ $index + 1 }}</div>
        </template>
      </el-table-column>

      <el-table-column prop="planName" label="计划名称" show-overflow-tooltip></el-table-column>
      <el-table-column prop="projectNameForBudget" label="项目/组名称" show-overflow-tooltip></el-table-column>
      <el-table-column prop="mediaName" label="媒体"></el-table-column>
      <el-table-column prop="paperUseAmount" label="当日消耗" show-overflow-tooltip></el-table-column>
      <el-table-column prop="projectTargetBid" label="项目/组出价" show-overflow-tooltip></el-table-column>
      <el-table-column prop="projectDeepBid" label="项目/组深度出价" show-overflow-tooltip></el-table-column>
      <el-table-column prop="bid" label="计划出价" show-overflow-tooltip></el-table-column>
      <el-table-column prop="deepCpabid" label="计划深度出价" show-overflow-tooltip></el-table-column>
      <el-table-column prop="projectRoi" label="项目/组ROI出价" show-overflow-tooltip></el-table-column>
      <el-table-column prop="roiRatio" label="计划ROI出价" show-overflow-tooltip></el-table-column>
      <el-table-column fixed="right" width="120">
        <template slot="header" slot-scope="scope">
          <span :class="scope.a">修改后项目/组出价</span>
          <el-button v-if="!submitFlag" type="text" @click="removeColValue('projectTargetBid')">清除</el-button>
        </template>
        <template slot-scope="{ row }">
          <!-- row.editStates 定义在 makeBatchBidRows src/views/promote/plandata/components/hooks/useBatchBid.js -->
          <span v-if="row.editStates.projectTargetBid.success">{{ row.submitResult.projectBid }}</span>
          <span v-if="row.editStates.projectTargetBid.unchange">{{ row.result.projectTargetBid }}</span>
          <BidInputPopover v-if="row.editStates.projectTargetBid.editable" v-model="row.result.projectTargetBid"></BidInputPopover>
        </template>
      </el-table-column>
      <el-table-column fixed="right" width="120">
        <template slot="header" slot-scope="scope">
          <span :class="scope.a">修改后项目/组深度出价</span>
          <el-button v-if="!submitFlag" type="text" @click="removeColValue('projectDeepBid')">清除</el-button>
        </template>
        <template slot-scope="{ row }">
          <span v-if="row.editStates.projectDeepBid.success">{{ row.submitResult.projectDeepbid }}</span>
          <span v-if="row.editStates.projectDeepBid.unchange">{{ row.result.projectDeepBid }}</span>
          <BidInputPopover v-if="row.editStates.projectDeepBid.editable" v-model="row.result.projectDeepBid"></BidInputPopover>
        </template>
      </el-table-column>
      <el-table-column fixed="right" width="110">
        <template slot="header" slot-scope="scope">
          <span :class="scope.a">修改后计划出价</span>
          <el-button v-if="!submitFlag" type="text" @click="removeColValue('bid')">清除</el-button>
        </template>

        <template slot-scope="{ row }">
          <span v-if="row.editStates.bid.success">{{ row.submitResult.adBid }}</span>
          <span v-if="row.editStates.bid.unchange">{{ row.result.bid }}</span>
          <BidInputPopover v-if="row.editStates.bid.editable" v-model="row.result.bid"></BidInputPopover>
        </template>
      </el-table-column>

      <el-table-column fixed="right" width="110">
        <template slot="header" slot-scope="scope">
          <span :class="scope.a">修改后计划深度出价</span>
          <el-button v-if="!submitFlag" type="text" @click="removeColValue('deepCpabid')">清除</el-button>
        </template>
        <template slot-scope="{ row }">
          <span v-if="row.editStates.deepCpabid.success">{{ row.submitResult.adDeepbid }}</span>
          <span v-if="row.editStates.deepCpabid.unchange">{{ row.result.deepCpabid }}</span>
          <BidInputPopover v-if="row.editStates.deepCpabid.editable" v-model="row.result.deepCpabid"></BidInputPopover>
        </template>
      </el-table-column>

      <el-table-column fixed="right" width="120">
        <template slot="header" slot-scope="scope">
          <span :class="scope.a">修改后项目/组ROI出价</span>
          <el-button v-if="!submitFlag" type="text" @click="removeColValue('projectRoi')">清除</el-button>
        </template>
        <template slot-scope="{ row }">
          <span v-if="row.editStates.projectRoi.success">{{ row.submitResult.projectRoibid }}</span>
          <span v-if="row.editStates.projectRoi.unchange">{{ row.result.projectRoi }}</span>
          <BidInputPopover
            :precision="getInputPrecision(row.mediaId)"
            :max="10"
            v-if="row.editStates.projectRoi.editable"
            v-model="row.result.projectRoi"
          ></BidInputPopover>
        </template>
      </el-table-column>

      <el-table-column fixed="right" width="110">
        <template slot="header" slot-scope="scope">
          <span :class="scope.a">修改后计划ROI出价</span>
          <el-button v-if="!submitFlag" type="text" @click="removeColValue('roiRatio')">清除</el-button>
        </template>
        <template slot-scope="{ row }">
          <span v-if="row.editStates.roiRatio.success">{{ row.submitResult.adRoibid }}</span>
          <span v-if="row.editStates.roiRatio.unchange">{{ row.result.roiRatio }}</span>
          <BidInputPopover
            :precision="getInputPrecision(row.mediaId)"
            :max="10"
            v-if="row.editStates.roiRatio.editable"
            v-model="row.result.roiRatio"
          ></BidInputPopover>
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作" width="120">
        <template slot-scope="{ $index, row }">
          <el-button v-if="!row.submitStates" @click="onRowRemove($index)" type="text">移除</el-button>

          <span v-else class="modify-status">
            <template v-if="row.submitStates.hasFailed">
              <el-button :loading="row.retryLoading" type="text" @click="failedRowRetry(row)">重试</el-button>

              <span class="error"> <em class="el-icon-error"></em>修改失败</span>
              <el-tooltip popper-class="result-error-msg-popover" effect="dark" :content="row.submitStates.errorMsg">
                <em v-if="row.submitStates.errorMsg" style="margin-left: 5px" class="el-icon-warning-outline"></em>
              </el-tooltip>
            </template>

            <template v-else-if="row.submitStates.unchanged">
              <span><em class="el-icon-warning-outline"></em>未修改</span>
            </template>

            <template v-else>
              <span class="success"> <em class="el-icon-circle-check"></em> 修改成功</span>
            </template>
          </span>
        </template>
      </el-table-column>
    </el-table>

    <span slot="footer" class="dialog-footer">
      <el-button @click="onBatchModifyCancel">取 消</el-button>
      <el-button v-if="submitFlag" type="primary" @click="onBatchModifyCancel">知道了</el-button>
      <el-button v-else type="primary" :loading="confirmLoading" :disabled="rows.length === 0" @click="onBatchModifyConfirm">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { truncatedNumber } from '@/common/js/utils.js'
import BidInputPopover from './bid-popover.vue'
import { batchBidModify } from '@/api/convert.model'

const settingTypes = [
  {
    label: '项目/组出价',
    value: 'projectTargetBid'
  },
  {
    label: '项目/组深度出价',
    value: 'projectDeepBid'
  },
  {
    label: '计划出价',
    value: 'bid'
  },
  {
    label: '计划深度出价',
    value: 'deepCpabid'
  },
  {
    label: '项目/组ROI出价',
    value: 'projectRoi'
  },
  {
    label: '计划ROI出价',
    value: 'roiRatio'
  }
]

const getForm = () => {
  return {
    settingType: settingTypes[0].value,
    bidType: 1,
    unitType: 1,
    bidValue: ''
  }
}
export default {
  props: {
    value: Boolean,
    title: String,
    rows: {
      type: Array
    }
  },
  components: { BidInputPopover },
  data() {
    return {
      settingTypes,
      submitFlag: false, // 提交标识，只有在第一次修改后才会置为true
      confirmLoading: false,
      form: getForm()
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  methods: {
    /**
     * @description: 统一修改列中的出价值
     */
    onBidValueConfirm() {
      let { settingType, bidValue } = this.form
      bidValue = Number(bidValue)

      if (typeof bidValue !== 'number' || isNaN(bidValue)) return this.$Message.warning('请输入数字')
      if (bidValue < 0) return this.$Message.warning('出价须大于0')

      const roiTypes = settingTypes.filter((t) => t.label.includes('ROI')).map((t) => t.value)

      const newList = this.rows.map((row) => {
        const newRow = { ...row }
        // 过滤掉不能修改的列
        if (this.isNumeric(newRow.result[settingType])) {
          let value = ''
          // roi类型
          if (roiTypes.includes(settingType)) {
            // 头条允许小数点后四位
            if (newRow.mediaId === 10) {
              value = truncatedNumber(parseFloat(bidValue), 4)
            }
            // 腾讯广告允许小数点后三位
            if (newRow.mediaId === 16) {
              value = truncatedNumber(parseFloat(bidValue), 3)
            }
          } else {
            // 其他出价类型只允许小数点后两位
            value = truncatedNumber(parseFloat(bidValue))
          }

          newRow.result[settingType] = value
        }
        return newRow
      })

      this.$emit('update-rows', newList)
    },
    buildParams() {
      const params = this.rows.map((row) => {
        const param = {
          planId: row.planId,
          mediaId: row.mediaId,
          adId: row.adIdForBudget,
          projectId: row.projectIdForBudget
        }

        // 目前只有头条uba可以修改项目出价、roi，没有修改则不传
        if (row.touTiaoUba) {
          if (this.isNumeric(row.projectTargetBid) && row.projectTargetBid !== row.result.projectTargetBid) {
            param.projectBid = row.result.projectTargetBid
          }

          if (this.isNumeric(row.projectDeepBid) && row.projectDeepBid !== row.result.projectDeepBid) {
            param.projectDeepbid = row.result.projectDeepBid
          }

          if (this.isNumeric(row.projectRoi) && row.projectRoi !== row.result.projectRoi) {
            param.projectRoibid = row.result.projectRoi
          }
        }

        // 修改广告出价，如果没有修改则不传
        if (this.isNumeric(row.bid) && row.result.bid !== row.bid) {
          param.adBid = row.result.bid
        }

        // 修改广告深度出价，如果没有修改则不传
        if (this.isNumeric(row.deepCpabid) && row.result.deepCpabid !== row.deepCpabid) {
          param.adDeepbid = row.result.deepCpabid
        }

        // 修改广告ROI出价，如果没有修改则不传
        if (this.isNumeric(row.roiRatio) && row.result.roiRatio !== row.roiRatio) {
          param.adRoibid = row.result.roiRatio
        }

        return param
      })

      return params
    },
    /**
     * @description: 提交
     */
    onBatchModifyConfirm() {
      const params = {
        task_list: this.buildParams()
      }
      this.confirmLoading = true
      batchBidModify(params)
        .then((data) => {
          // 在当前表格中显示提交结果，并可以对失败的结果修改后重试
          const newList = this.rows.map((row) => {
            const resultRow = data.find((d) => row.planId === d.planId)
            const { hasFailed, unchanged, errorMsg } = this.getRowSubmitInfo(resultRow)
            return {
              ...row,
              submitResult: resultRow, // 保存返回结果
              submitStates: {
                hasFailed,
                errorMsg,
                unchanged
              }
            }
          })

          this.$emit('update-rows', newList)
          this.submitFlag = true

          this.$emit('refresh')
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },

    buildRetryParams(row) {
      const param = {
        planId: row.planId,
        mediaId: row.mediaId,
        adId: row.adIdForBudget,
        id: row.submitResult.id
      }

      for (const key in row.submitResult) {
        // 找到状态为2（失败）的出价，只提交失败的出价
        if (key.endsWith('Status')) {
          const bidStatus = row.submitResult[key]
          if (bidStatus === 2) {
            if (key === 'projectBidStatus') {
              param.projectBid = row.result.projectTargetBid
            }
            if (key === 'projectDeepbidStatus') {
              param.projectDeepbid = row.result.projectDeepBid
            }
            if (key === 'projectRoibidStatus') {
              param.projectRoibid = row.result.projectRoi
            }

            if (key === 'adBidStatus') {
              param.adBid = row.result.bid
            }

            if (key === 'adDeepbidStatus') {
              param.adDeepbid = row.result.deepCpabid
            }

            if (key === 'adRoibidStatus') {
              param.adRoibid = row.result.roiRatio
            }
          }
        }
      }
      return param
    },
    /**
     * @description: 失败结果重试
     */
    failedRowRetry(row) {
      const params = {
        task_list: [this.buildRetryParams(row)]
      }
      this.$set(row, 'retryLoading', true)
      batchBidModify(params)
        .then((data) => {
          const [resultRow] = data
          const { hasFailed, unchanged, errorMsg } = this.getRowSubmitInfo(resultRow)

          const newList = this.rows.map((r) => {
            if (r.planId === row.planId) {
              return {
                ...r,
                retryLoading: false,
                submitResult: resultRow, // 保存返回结果
                submitStates: {
                  hasFailed,
                  errorMsg,
                  unchanged
                }
              }
            }
            return r
          })
          this.$emit('update-rows', newList)
        })
        .finally(() => {
          this.$set(row, 'retryLoading', false)
        })
    },
    onBatchModifyCancel() {
      this.dialogVisible = false
      this.confirmLoading = false
      this.submitFlag = false
      this.form = getForm()
    },

    onRowRemove(idx) {
      const newList = this.rows.filter((_, index) => index !== idx)
      this.$emit('update-rows', newList)
    },
    removeColValue(col) {
      const newList = this.rows.map((row) => ({ ...row, result: { ...row.result, [col]: '-' } }))
      this.$emit('update-rows', newList)

      this.form.bidValue = ''
    },
    isNumeric(val) {
      return !isNaN(val) && !isNaN(parseFloat(val))
    },
    getRowSubmitInfo(row) {
      const msgList = []
      const submitStateList = []

      for (const key in row) {
        if (key.endsWith('Msg')) {
          msgList.push(row[key])
        }

        if (key.endsWith('Status')) {
          submitStateList.push(row[key])
        }
      }

      // 过滤掉null
      return {
        errorMsg: msgList.filter((msg) => msg).join('；'),
        hasFailed: submitStateList.includes(2),
        unchanged: submitStateList.every((state) => state === -1)
      }
    },
    /**
     * @description: 头条允许小数点后四位、腾讯广告允许小数点后三位
     * @param {*} mediaId
     */
    getInputPrecision(mediaId) {
      switch (mediaId) {
        case 10:
          return 4
        case 16:
          return 3
        default:
          return 2
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.input-row {
  display: flex;
  .el-button {
    margin-left: 10px;
  }
}
.modal-title {
  display: flex;
  align-items: center;
  h4 {
    font-size: 18px;
  }
  span {
    margin-left: 20px;
  }
}
.bid-input {
  margin-left: 5px;
  ::v-deep .el-input-group__append {
    width: 70px;
  }
}

.modify-status {
  .success {
    color: green;
  }

  .error {
    color: red;
  }
}
</style>
